import { render, staticRenderFns } from "./TheProductDetailsSizeSelector.vue?vue&type=template&id=6fe5a492&"
import script from "./TheProductDetailsSizeSelector.vue?vue&type=script&lang=js&"
export * from "./TheProductDetailsSizeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe5a492')) {
      api.createRecord('6fe5a492', component.options)
    } else {
      api.reload('6fe5a492', component.options)
    }
    module.hot.accept("./TheProductDetailsSizeSelector.vue?vue&type=template&id=6fe5a492&", function () {
      api.rerender('6fe5a492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductDetailsSizeSelector.vue"
export default component.exports